import type { CategoryAction } from '@/types';

export const CATEGORY_JOBS_STORAGE_KEY = 'categoryJobs';
export const CATEGORY_JOBS_UPDATED_EVENT = 'categoryJobsStorageUpdated';

export enum CategoryJobAction {
    assign = 'Assign',
    unassign = 'Unassign',
}

export const AVAILABLE_CATEGORY_ACTIONS: CategoryAction[] = ['assign', 'unassign'];

export const CATEGORY_ACTION_OPTIONS = [
    {
        label: CategoryJobAction.assign,
        value: 'assign' as CategoryAction,
    },
    {
        label: CategoryJobAction.unassign,
        value: 'unassign' as CategoryAction,
    },
];

export {
    ACTIVE_STATUSES,
    API_BASE_URL,
    API_TIMEOUT_MS,
    BULK_PROMO_SUPPORT_TICKET_URL,
    FAILED_SKUS_PAGE_SIZE,
    MEGABYTES_IN_BYTES,
    POLL_INTERVAL_MS,
    TOKEN_CHECK_INTERVAL,
} from './common';
export { ID_TOKEN } from './cookies';
export { REQUESTOR_KEY, SHOP_CATEGORY_STORAGE_KEY, USER_DATA_KEY } from './localStorage';
export { PAGE_ROUTE_TO_TITLE, SIDEBAR_MENU_ITEMS, USER_MENU_ITEMS } from './navigation';
export {
    AVAILABLE_ACTIONS,
    BulkPromoAction,
    JOBS_STORAGE_KEY,
    JOBS_UPDATED_EVENT,
    PROMO_OFFER_NAME_ATTRIBUTE,
    PromoJobAction,
    PromoJobStatus,
    promoActionOptions,
} from './promoOffer';
